import {QueryClient} from '@tanstack/react-query';

export default new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      retryDelay: 3000,
    },
    mutations: {
      retry: 0,
    },
  },
});
